import { StatusBar } from 'expo-status-bar';
import React from 'react';

import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';

import ic from './src/c_20211020a_YSh/ic';
import ce from './src/c_20211020a_YSh/ce';
//import cf from './src/c_20211020a_YSh/cf';

import c00v1a from './src/c_20211020a_YSh/c00v1a'; // ログイン
import c00vm from './src/c_20211020a_YSh/c00vm'; // ログイン（団体用メールアドレス登録）
import c00v2a from './src/c_20211020a_YSh/c00v2a'; // ユーザ切替
import c20v1a from './src/c_20211020a_YSh/c20v1a'; // 管理用クライアント画面
import c10v1a from './src/c_20211020a_YSh/c10v1a'; // スタッフ用スタッフ情報
//import c10v1b from './src/c_20211020a_YSh/c10v1b'; // スタッフ用団体情報 // 廃止予定
//import c10v2b from './src/c_20211020a_YSh/c10v2b'; // 団体用設定
import c30v1a from './src/c_20211020a_YSh/c30v1a'; // スタッフ用団体登録
import c30v2a from './src/c_20211020a_YSh/c30v2a'; // 団体用設定
import c30v3a from './src/c_20211020a_YSh/c30v3a'; // 団体用メールアドレス登録
import c40v1a from './src/c_20211020a_YSh/c40v1a'; // モジュール
import c41v1a from './src/c_20211020a_YSh/c41v1a'; // 役割
import c42v1a from './src/c_20211020a_YSh/c42v1a'; // 担当
import c51v1a from './src/c_20211020a_YSh/c51v1a'; // 設定
import c60v1a from './src/c_20211020a_YSh/c60v1a'; // 休日カレンダー
import c70v1a from './src/c_20211020a_YSh/c70v1a'; // 管理用祝日カレンダー
import i10v1a from './src/c_20211020a_YSh/i10v1a'; // 設備
import i11v1a from './src/c_20211020a_YSh/i11v1a'; // 時間帯
//import i13v1a from './src/c_20211020a_YSh/i13v1a'; // 団体
//import i14v1a from './src/c_20211020a_YSh/i14v1a'; // 設定
import i15v1a from './src/c_20211020a_YSh/i15v1a'; // 団体種別
import i16v1a from './src/c_20211020a_YSh/i16v1a'; // ジャンル
import i1zv1a from './src/c_20211020a_YSh/i1zv1a'; // スタッフ用 予約
import i1zv1b from './src/c_20211020a_YSh/i1zv1b'; // スタッフ用 エントリー
import i1zv1c from './src/c_20211020a_YSh/i1zv1c'; // スタッフ用 優先エントリー
import i1zv2a from './src/c_20211020a_YSh/i1zv2a'; // 団体用 予約
import i1zv2b from './src/c_20211020a_YSh/i1zv2b'; // 団体用 エントリー
import i1zv2c from './src/c_20211020a_YSh/i1zv2c'; // 団体用 優先エントリー
import i1zv3a from './src/c_20211020a_YSh/i1zv3a'; // スタッフ用 使用状況（日次）
import i1zv3b from './src/c_20211020a_YSh/i1zv3b'; // スタッフ用 サイネージ
import i1zv4a from './src/c_20211020a_YSh/i1zv4a'; // スタッフ用 予約状況カレンダー スタッフ用
import cdr from './src/c_20211020a_YSh/cdr'; // スタッフ用 予約状況カレンダー 一般公開用
import i1zv5a from './src/c_20211020a_YSh/i1zv5a'; // スタッフ用 定期予約一括登録
import i1zv6a from './src/c_20211020a_YSh/i1zv6a'; // スタッフ用 実績集計表
import i1zv7a from './src/c_20211020a_YSh/i1zv7a'; // スタッフ用 月間予約一括登録
import i1zv8a from './src/c_20211020a_YSh/i1zv8a'; // スタッフ用 支払状況
import i1yv1a from './src/c_20211020a_YSh/i1yv1a'; // エントリー抽選
import i1yv1b from './src/c_20211020a_YSh/i1yv1b'; // 優先エントリー抽選
import iHome1 from './src/c_20211020a_YSh/iHome1'; // スタッフ用ホーム
import iHome2 from './src/c_20211020a_YSh/iHome2'; // 団体用ホーム
import iStg1 from './src/c_20211020a_YSh/iStg1'; // スタッフ用設定

const Stack = createStackNavigator();

//if (cf.myRN_chk_os('w')) document.documentElement.lang = 'ja'; // 言語設定

global.d_crls = {};

export default function App() {

  return (
    <NavigationContainer
      linking={{
        prefixes: [ic.g_url0],
      }}
    >
      <Stack.Navigator
          initialRouteName={ic.g_iniPageName}
      >
        <Stack.Screen
          name='c00v1a'
          component={c00v1a}
          initialParams={{}}
          options={{
            title: 'ログイン',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c00vm'
          component={c00vm}
          initialParams={{}}
          options={{
            title: 'メールアドレス登録',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c00v2a'
          component={c00v2a}
          initialParams={{}}
          options={{
            title: 'ユーザ切替',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c20v1a'
          component={c20v1a}
          initialParams={{}}
          options={{
            title: 'クライアント',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c10v1a'
          component={c10v1a}
          initialParams={{}}
          options={{
            title: 'スタッフ',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c30v1a'
          component={c30v1a}
          initialParams={{}}
          options={{
            title: '団体登録',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c30v2a'
          component={c30v2a}
          initialParams={{}}
          options={{
            title: '設定',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c30v3a'
          component={c30v3a}
          initialParams={{}}
          options={{
            title: '設定',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c40v1a'
          component={c40v1a}
          initialParams={{}}
          options={{
            title: 'モジュール',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c41v1a'
          component={c41v1a}
          initialParams={{}}
          options={{
            title: '役割',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c42v1a'
          component={c42v1a}
          initialParams={{}}
          options={{
            title: '担当',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c60v1a'
          component={c60v1a}
          initialParams={{}}
          options={{
            title: '休日',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c70v1a'
          component={c70v1a}
          initialParams={{}}
          options={{
            title: '祝日',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i11v1a'
          component={i11v1a}
          initialParams={{}}
          options={{
            title: '時間帯',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i10v1a'
          component={i10v1a}
          initialParams={{}}
          options={{
            title: '室・設備',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='c51v1a'
          component={c51v1a}
          initialParams={{}}
          options={{
            title: '設定',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i15v1a'
          component={i15v1a}
          initialParams={{}}
          options={{
            title: '団体種別',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i16v1a'
          component={i16v1a}
          initialParams={{}}
          options={{
            title: 'ジャンル',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv1a'
          component={i1zv1a}
          initialParams={{}}
          options={{
            title: '直接予約',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv1b'
          component={i1zv1b}
          initialParams={{}}
          options={{
            title: 'エントリー',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv1c'
          component={i1zv1c}
          initialParams={{}}
          options={{
            title: '優先エントリー',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv2a'
          component={i1zv2a}
          initialParams={{}}
          options={{
            title: '直接予約',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv2b'
          component={i1zv2b}
          initialParams={{}}
          options={{
            title: 'エントリー',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv2c'
          component={i1zv2c}
          initialParams={{}}
          options={{
            title: '優先エントリー',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv3a'
          component={i1zv3a}
          initialParams={{}}
          options={{
            title: '使用状況',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv3b'
          component={i1zv3b}
          initialParams={{}}
          options={{
            title: 'サイネージ',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv4a'
          component={i1zv4a}
          initialParams={{}}
          options={{
            title: '予約状況カレンダー',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='cdr'
          component={cdr}
          initialParams={{}}
          options={{
            title: '予約状況カレンダー',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv5a'
          component={i1zv5a}
          initialParams={{}}
          options={{
            title: '定期予約一括登録',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv6a'
          component={i1zv6a}
          initialParams={{}}
          options={{
            title: '実績集計表',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv7a'
          component={i1zv7a}
          initialParams={{}}
          options={{
            title: '月間予約一括登録',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1zv8a'
          component={i1zv8a}
          initialParams={{}}
          options={{
            title: '支払状況',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1yv1a'
          component={i1yv1a}
          initialParams={{}}
          options={{
            title: 'エントリー抽選',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='i1yv1b'
          component={i1yv1b}
          initialParams={{}}
          options={{
            title: '優先エントリー抽選',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='iHome1'
          component={iHome1}
          initialParams={{}}
          options={{
            title: 'ホーム',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='iHome2'
          component={iHome2}
          initialParams={{}}
          options={{
            title: 'ホーム',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

        <Stack.Screen
          name='iStg1'
          component={iStg1}
          initialParams={{}}
          options={{
            title: '設定',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

      </Stack.Navigator>
    </NavigationContainer>
  );

};
/*
        <Stack.Screen
          name='i13v1a'
          component={i13v1a}
          initialParams={{}}
          options={{
            title: 'ユーザー',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
         <Stack.Screen
          name='c10v1b'
          component={c10v1b}
          initialParams={{}}
          options={{
            title: '団体登録',
            headerShown: false, 
            animationEnabled: false,
          }}
        />

 */